
export default {
  path: 'invoicing',
  name: 'admin.invoicing',
  component: () => import(/* webpackChunkName: "adminUser" */ '@/app/admin/invoicing/invoicing.vue'),
};
